
import Cookies from 'js-cookie'

export const getLanguage = () => Cookies.get('language_key')
export const setLanguage = (language: string) => Cookies.set('language_key', language)

export const getIframePath = () => Cookies.get('iframe_path')
export const setIframePath = (language: string) => Cookies.set('iframe_path', language)
